export { default as hairscalp } from './hairscalp';
